var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center xprogress"},_vm._l((_vm.progressLogs),function(v,k){return _c('div',{staticClass:"sparkline"},[_vm._v(" "+_vm._s(k)+" "),_c('highcharts',{attrs:{"options":_vm.options(k, v)}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }